import { createContext, useContext } from "react";

interface SectorConnectionContextValue {
  connected: boolean;
  isInitializing: boolean;
}

export const SectorConnectionContext =
  createContext<SectorConnectionContextValue>({
    connected: false,
    isInitializing: false,
  });

export const useSectorConnection = () => useContext(SectorConnectionContext);
